import { render } from "./ActionGroup.vue?vue&type=template&id=e6ffb06a&scoped=true"
import script from "./ActionGroup.vue?vue&type=script&lang=js"
export * from "./ActionGroup.vue?vue&type=script&lang=js"

import "./ActionGroup.vue?vue&type=style&index=0&id=e6ffb06a&scoped=true&lang=scss"

import exportComponent from "D:\\project\\php\\quickadmin\\vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6ffb06a"]])

export default __exports__